import script from "./InvestigationInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationInvoice.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationInvoice.vue?vue&type=style&index=0&id=fbcb7b36&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbcb7b36"]])

export default __exports__